import React from 'react';
import { Environment as DreiEnvironment } from '@react-three/drei';
import {
  EffectComposer,
  Bloom,
  SSAO,
  Vignette,
  SMAA,
  BrightnessContrast,
  HueSaturation,
  GodRays,
} from '@react-three/postprocessing';
import { KernelSize } from 'postprocessing';
import { getLookPreset } from '../../../settings/render';
import { applyGfxToPostfx } from '../../../settings/gfx.quality';

/**
 * IBL from local HDR (compressed 1k).
 */
export const SceneEnvironment = ({ look }) => {

  const preset = look || getLookPreset();
  const env = preset.environment;

  return (

    <DreiEnvironment

      files = { env.files }
      background = { env.background }

    />

  );

}

export const ScenePostFX = ({ look, sun }) => {

  const preset = look || getLookPreset();
  const fx = applyGfxToPostfx( preset.postfx );
  const grade = preset.grade || {};

  if ( !fx?.enabled ) return null;

  const bloomOn = ( fx.bloom?.intensity || 0 ) > 0;
  const godRaysOn = !!( fx.godRays && sun );
  const gradeOn = fx.colorGrade !== false;

  // Skip EffectComposer entirely when nothing to do (mobile / low)
  if ( !bloomOn && !godRaysOn && !fx.vignette && !fx.smaa && !gradeOn && !fx.ssao?.enabled ) {

    return null;

  }

  return (

    <EffectComposer multisampling = { 0 } disableNormalPass = { !fx.ssao?.enabled }>

      { fx.ssao?.enabled && (

        <SSAO

          samples = { fx.ssao.samples }
          radius = { fx.ssao.radius }
          intensity = { fx.ssao.intensity }
          luminanceInfluence = { fx.ssao.luminanceInfluence }
        />

      )}

      { godRaysOn && (

        <GodRays

          sun = { sun }
          samples = { 40 }
          density = { 0.92 }
          decay = { 0.94 }
          weight = { 0.35 }
          exposure = { 0.45 }
          clampMax = { 0.9 }
          blur = { true }
          kernelSize = { KernelSize.SMALL }

        />

      )}

      { bloomOn && (

        <Bloom

          luminanceThreshold = { fx.bloom.luminanceThreshold }
          luminanceSmoothing = { fx.bloom.luminanceSmoothing }
          intensity = { fx.bloom.intensity }
        />

      )}

      { gradeOn && (

        <BrightnessContrast

          brightness = { grade.brightness ?? 0 }
          contrast = { grade.contrast ?? 0.1 }

        />

      )}

      { gradeOn && (

        <HueSaturation

          hue = { grade.hue ?? 0 }
          saturation = { grade.saturation ?? 0.08 }

        />

      )}

      { fx.vignette && (

        <Vignette

          eskil = { false }
          offset = { fx.vignette.offset }
          darkness = { fx.vignette.darkness }
        />

      )}

      { fx.smaa && <SMAA /> }

    </EffectComposer>

  );

}
